import { FormControlLabel, Checkbox, FormControl } from '@mui/material';
import { useFormContext, useController } from 'react-hook-form';
import { z } from 'zod';

export interface ISingleCheckboxProps {
	name: string;
	label: string;
	disabled?: boolean;
}

type ValueOf<T> = T[keyof T];

export const SingleCheckboxSchema = ((options) => {
	return {
		options,
		create: (fieldName: string, validation: ValueOf<typeof options>) => {
			return z.object({ [fieldName]: validation });
		},
	};
})({
	default: z.boolean(),
});

export default function SingleCheckbox({ name, label, disabled = false }: Readonly<ISingleCheckboxProps>) {
	const { control } = useFormContext();

	const { field } = useController({ name, control });

	return (
		<FormControl>
			<FormControlLabel
				control={
					<Checkbox
						name={name}
						color="secondary"
						onChange={(e) => {
							field.onChange(e.target.checked);
						}}
						checked={field.value === true}
						disabled={disabled}
					/>
				}
				label={label}
				componentsProps={{
					typography: {
						variant: 'bodyMediumBook',
						color: 'text.secondary',
					},
				}}
			/>
		</FormControl>
	);
}
